export const isImageChatMessage = (message = {}) =>
  String(message?.message_format || '').toLowerCase() === 'image' &&
  Boolean(message?.image_file_name || message?.image_url || message?.image_id);

const normalizeNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : null;
};

export const getImageGroupKey = (message = {}) => {
  const groupId = String(message?.image_group_id || '').trim();
  const groupCount = normalizeNumber(message?.image_group_count);
  if (groupId && groupCount && groupCount > 1) return `group:${groupId}`;
  return `single:${message?.id || message?.message_id || message?.image_id || message?.image_file_name || ''}`;
};

export const buildImageGroupDisplayMessages = (messages = []) => {
  const groups = new Map();
  const order = [];

  messages.forEach((message) => {
    if (!isImageChatMessage(message)) {
      order.push({ type: 'single', message });
      return;
    }
    const key = getImageGroupKey(message);
    if (!key.startsWith('group:')) {
      order.push({ type: 'single', message });
      return;
    }
    if (!groups.has(key)) {
      groups.set(key, []);
      order.push({ type: 'group', key });
    }
    groups.get(key).push(message);
  });

  return order
    .map((entry) => {
      if (entry.type === 'single') return entry.message;
      const items = (groups.get(entry.key) || [])
        .slice()
        .sort((left, right) => {
          const leftOrder = Number.isFinite(Number(left?.image_group_order))
            ? Number(left.image_group_order)
            : 0;
          const rightOrder = Number.isFinite(Number(right?.image_group_order))
            ? Number(right.image_group_order)
            : 0;
          return leftOrder - rightOrder;
        });
      if (!items.length) return null;
      if (items.length === 1) return items[0];
      return { ...items[0], image_group_items: items };
    })
    .filter(Boolean);
};

export const clampSingleImageAspectRatio = (width, height) => {
  const safeWidth = normalizeNumber(width);
  const safeHeight = normalizeNumber(height);
  if (!safeWidth || !safeHeight) return 4 / 3;
  const ratio = safeWidth / safeHeight;
  if (!Number.isFinite(ratio) || ratio <= 0) return 4 / 3;
  return Math.min(Math.max(ratio, 0.75), 1.78);
};

export const buildImageDownloadName = (item = {}, index = 0) => {
  const sourceName = String(item?.fileName || item?.image_file_name || item?.name || '').trim();
  if (sourceName) return sourceName;
  return `chat-image-${String(index + 1).padStart(2, '0')}.jpg`;
};
